import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {multiLineTruncate} from '@travel-frontend/ui-components';

export const Headline = styled.div(
  ({theme}) => css`
    ${theme.typography.display};
    color: ${theme.colors.contentInversePrimary};
    ${multiLineTruncate(3)};
    /* @FIXME add dedicated text-shadow tokens to toolkit? */
    text-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  `
);
